<script>
import Base from './default.vue';

export default {
  name: 'SignUpLayout',
  extends: Base,
  middleware: ['mobile-app-check']
};
</script>
